import { create } from 'zustand';

interface ConfirmState {
  isOpen: boolean;
  title: string;
  message: string;
  confirmLabel: string;
  cancelLabel: string;
  isDestructive: boolean;
  onConfirm: (() => void) | null;
  onCancel: (() => void) | null;
  
  confirm: (options: {
    title: string;
    message: string;
    confirmLabel?: string;
    cancelLabel?: string;
    isDestructive?: boolean;
    onConfirm: () => void;
    onCancel?: () => void;
  }) => void;
  close: () => void;
}

export const useConfirmStore = create<ConfirmState>((set) => ({
  isOpen: false,
  title: '',
  message: '',
  confirmLabel: 'Confirm',
  cancelLabel: 'Cancel',
  isDestructive: false,
  onConfirm: null,
  onCancel: null,

  confirm: (options) => set({
    isOpen: true,
    title: options.title,
    message: options.message,
    confirmLabel: options.confirmLabel || 'Confirm',
    cancelLabel: options.cancelLabel || 'Cancel',
    isDestructive: options.isDestructive || false,
    onConfirm: options.onConfirm,
    onCancel: options.onCancel || null,
  }),
  close: () => set({ isOpen: false, onConfirm: null, onCancel: null })
}));
